import styles from "./navbar.module.css";
// profile.tailwind.js
const profileStyles = {
    container: `relative flex items-center justify-between gap-3`,
    username: `text-white text-[14px] font-[400] hidden ${styles.username}
                sm:block
    `,
    profileImage: `w-[40px] h-[40px] rounded-full overflow-hidden cursor-pointer border border-primaryHeading
                    md:w-[45px] md:h-[45px] ${styles.profileImage}
    `,
    dropdown: `absolute right-0 mt-2 w-32 bg-gray-800 rounded-md shadow-lg`,
    logoutButton: `block w-full text-left px-4 py-2 text-white hover:bg-gray-700 transition-all duration-300`,
    profileIcon:`w-full h-full object-cover bg-white `
};

export { profileStyles };